import { Pipe, PipeTransform } from '@angular/core';
import { isIsoDate, isIsoDateTime, isIsoDateTimeTz } from '@softline/core';

@Pipe({
  name: 'isIsoDate',
  standalone: true,
  pure: true
})
export class IsIsoDatePipe implements PipeTransform {
  transform(value: string): boolean {
    return isIsoDate(value)
      || isIsoDateTime(value)
      || isIsoDateTimeTz(value)
  }
}
